// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2rjWO","rootSmall":"AddTileButton_rootSmall__381uV"};